export enum TABLE_SECURITY_WORDS {
    SHOW = 2,
    EDIT = 4,
    DELETE = 8,
    CREATE = 1024
};